module.exports = __webpack_public_path__ + "static/media/hat.7d40c97a.png";